import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/envs/environnement';

export interface PreferenceUtilisateurDto {
    id?: string;
    userId?: string;
    theme?: 'LIGHT' | 'DARK' | 'SYSTEM';
    langue?: string;
    notificationEmail?: boolean;
    notificationWhatsapp?: boolean;
    notificationDashboard?: boolean;
    conditionsAcceptees?: boolean;
    guideSuivi?: boolean;
}

@Injectable({ providedIn: 'root' })
export class PreferenceService {
    private readonly url = `${environment.baseUrl}/preferences/me`;

    constructor(private http: HttpClient) {}

    getPreferences(): Observable<PreferenceUtilisateurDto> {
        return this.http.get<PreferenceUtilisateurDto>(this.url);
    }

    savePreferences(dto: PreferenceUtilisateurDto): Observable<PreferenceUtilisateurDto> {
        return this.http.put<PreferenceUtilisateurDto>(this.url, dto);
    }
}
